import dynamic from 'next/dynamic'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'

import { constants, STATUS_LOGIN } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'
import { selectIsAuthenticated } from '@/store/selectors/user'
import { PageContainer } from '@/components/atomic/PageContainer'
import { PageMetaData } from '@/components/atomic/PageMetaData'
import { Header } from '@/components/styleguide/Header'

const Container = dynamic(() => import('@/components/views/AccountDetailsPage/Container'), {
  ssr: false,
})
const AccountHeader = dynamic(() => import('@/components/views/AccountDetailsPage/Header'), {
  ssr: false,
})
const AuthenticationProcess = dynamic(
  () => import('@/components/views/AuthenticationProcess'),
  {
    ssr: false,
  },
)

export default function AccountDetailsPage() {
  const router = useRouter()
  const isAuthenticated = useSelector(selectIsAuthenticated)

  return (
    <>
      <PageMetaData
        title="LocoSpace | LeaseLoco"
        description="Your LocoSpace is for all your preferences, price alerts, enquiries, rewards and much more."
        pageUrl={ROUTES.accountDetailsPage.url}
      />
      <Header
        backgroundColor="white"
      />
      <PageContainer containerClass="account-details">
        {isAuthenticated ? (
          <>
            <AccountHeader
              activeNav={router.query.area || constants.accountSections.PERSONAL.route}
            />
            <Container />
          </>
        ) : (
          <div className="unauthenticated">
            <AuthenticationProcess
              authPage={false}
              garagePage={false}
              closeModal={null}
              hideHeaders={false}
              initialStatus={STATUS_LOGIN}
              isEnquiry={false}
              isModal={false}
              setStatusHistory={undefined}
              shouldShowBackButton={false}
              getPreviousStatus={undefined}
              setUserState={() => {
                // do nothing
              }}
              key={null}
            />
            <Image
              className="mascot-image"
              src={`${constants.imageHost.assets}/mascot/full-body-3.png`}
              alt="Luis Loco"
              height="473"
              width="320"
            />
          </div>
        )}
      </PageContainer>
    </>
  )
}
